import { useStorage } from '@vueuse/core'

const isRounding = useStorage<boolean>(useStorageKey('isRounding'), true)

export function useRouding() {
  return isRounding
}